/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**********************************************!*\
  !*** ./src/scripts/sections/simple_video.js ***!
  \**********************************************/
var simpleVideo = function simpleVideo() {
  return {
    isPlaying: false,
    isMobile: false,
    previousIsMobile: false,
    progress: 0,
    desktopVideo: null,
    mobileVideo: null,
    isMuted: true,
    get currentVideo() {
      if (this.mobileVideo) {
        return this.isMobile ? this.mobileVideo : this.desktopVideo;
      } else {
        return this.desktopVideo;
      }
    },
    get isVideoPlaying() {
      var _this$currentVideo;
      return ((_this$currentVideo = this.currentVideo) === null || _this$currentVideo === void 0 ? void 0 : _this$currentVideo.paused) === false;
    },
    init: function init() {
      var _this$$refs = this.$refs,
        desktopVideo = _this$$refs.desktopVideo,
        mobileVideo = _this$$refs.mobileVideo;
      if (desktopVideo) {
        this.desktopVideo = desktopVideo.querySelector("video");
      }
      if (mobileVideo) {
        this.mobileVideo = mobileVideo.querySelector("video");
      }
      this.setupVideoListeners(this.desktopVideo);
      this.setupVideoListeners(this.mobileVideo);
      window.addEventListener("resize", this.handleResize.bind(this));
      this.updateMobileFlag();
      this.previousIsMobile = this.isMobile;
      this.currentVideo.muted = true;
    },
    setupVideoListeners: function setupVideoListeners(video) {
      var _this = this;
      if (!video) return;
      video.addEventListener("play", function () {
        return _this.isPlaying = true;
      });
      video.addEventListener("pause", function () {
        return _this.isPlaying = false;
      });
      video.addEventListener("timeupdate", function () {
        return _this.updateProgress();
      });
    },
    updateMobileFlag: function updateMobileFlag() {
      this.isMobile = window.innerWidth <= 990;
    },
    handleResize: function handleResize() {
      var previousMobileState = this.isMobile;
      this.updateMobileFlag();
      if (this.isMobile !== previousMobileState) {
        this.resetProgressAndPause();
      }
    },
    resetProgressAndPause: function resetProgressAndPause() {
      if (this.desktopVideo) {
        this.desktopVideo.muted = true;
        this.desktopVideo.pause();
      }
      if (this.mobileVideo) {
        this.mobileVideo.muted = true;
        this.mobileVideo.pause();
      }
      this.isMuted = true;
      this.progress = 0;
      if (this.currentVideo) {
        this.currentVideo.currentTime = 0;
      }
    },
    playPauseToggle: function playPauseToggle() {
      console.log("this.currentVideo", this.currentVideo);
      if (this.isVideoPlaying) {
        this.currentVideo.pause();
      } else {
        this.currentVideo.play();
      }
    },
    muteUnmuteToggle: function muteUnmuteToggle() {
      this.isMuted = !this.isMuted;
      this.currentVideo.muted = !this.currentVideo.muted;
    },
    updateProgress: function updateProgress() {
      if (this.currentVideo) {
        this.progress = this.currentVideo.currentTime / this.currentVideo.duration * 100;
      }
    }
  };
};
document.addEventListener("alpine:init", function () {
  Alpine.data("simple_video", simpleVideo);
});
/******/ })()
;